import { render, staticRenderFns } from "./BoxSliders.vue?vue&type=template&id=d9146a02&scoped=true&"
import script from "./BoxSliders.vue?vue&type=script&lang=js&"
export * from "./BoxSliders.vue?vue&type=script&lang=js&"
import style0 from "./BoxSliders.vue?vue&type=style&index=0&id=d9146a02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9146a02",
  null
  
)

export default component.exports